// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.listings.HpApiListingsV3Handler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiListingsV3Handler_detail,
  HpApiListingsV3Handler_detail_Path,
  HpApiListingsV3Handler_priceHistory,
  HpApiListingsV3Handler_priceHistory_Path,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpListingDetailResponseDto,
  HpPriceHistoryResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-hotpads-api-client';

interface DetailParams {
  includeBuildingReview?: boolean;
  includeReviews?: boolean;
  maloneLotIdEncoded: string;
  unit?: string;
}
interface PriceHistoryParams {
  listingAlias: ListingAlias;
  modelId: string;
}

export type HpApiListingsV3Handler_detail_Options = UseQueryOptions<
  HpApiResponseDto<HpListingDetailResponseDto>,
  unknown,
  HpApiResponseDto<HpListingDetailResponseDto>,
  readonly [string, DetailParams]
>;

const HpApiListingsV3Handler_detail_GetKey = (getParams: DetailParams) =>
  [HpApiListingsV3Handler_detail_Path, getParams] as const;

export const HpApiListingsV3Handler_detail_queryOptions = (
  getParams: DetailParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiListingsV3Handler_detail_GetKey(getParams),
    queryFn: () => HpApiListingsV3Handler_detail(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns building/listing detail by malone lot id
 */
export const useHpApiListingsV3Handler_detail = (
  getParams: DetailParams,
  {
    httpClient,
    ...options
  }: Omit<HpApiListingsV3Handler_detail_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiListingsV3Handler_detail_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useHpApiListingsV3Handler_detail.getKey = HpApiListingsV3Handler_detail_GetKey;

export type HpApiListingsV3Handler_priceHistory_Options = UseQueryOptions<
  HpApiResponseDto<HpPriceHistoryResponseDto>,
  unknown,
  HpApiResponseDto<HpPriceHistoryResponseDto>,
  readonly [string, PriceHistoryParams]
>;

const HpApiListingsV3Handler_priceHistory_GetKey = (getParams: PriceHistoryParams) =>
  [HpApiListingsV3Handler_priceHistory_Path, getParams] as const;

export const HpApiListingsV3Handler_priceHistory_queryOptions = (
  getParams: PriceHistoryParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: HpApiListingsV3Handler_priceHistory_GetKey(getParams),
    queryFn: () => HpApiListingsV3Handler_priceHistory(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Returns rental price history for an exact listing model
 */
export const useHpApiListingsV3Handler_priceHistory = (
  getParams: PriceHistoryParams,
  {
    httpClient,
    ...options
  }: Omit<HpApiListingsV3Handler_priceHistory_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...HpApiListingsV3Handler_priceHistory_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useHpApiListingsV3Handler_priceHistory.getKey = HpApiListingsV3Handler_priceHistory_GetKey;
